module.exports = __webpack_public_path__ + "img/img-3bb7d2.png";